import ApiService from '@/services/core/api.service'

const BudgetService = {
  async get (query) {
    return ApiService.get(`disbursement/budgets?${query}`)
  },

  async post (payload) {
    return ApiService.post('disbursement/budgets', payload)
  },

  async put (payload) {
    return ApiService.put(`disbursement/budgets/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`disbursement/budgets/${payload.id}`)
  }
}

export default BudgetService
